import { render, staticRenderFns } from "./PresentationBox.vue?vue&type=template&id=609c69ff"
import script from "./PresentationBox.vue?vue&type=script&lang=ts"
export * from "./PresentationBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports